var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "lc-category" } }, [
    _c("div", { staticClass: "lc-category-settings" }, [
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "mb-0 col mb-sm-2 simple-dropdown-wrapper" },
            [
              _c("p", { staticClass: "bodytext mb-1" }, [
                _vm._v(_vm._s(_vm.trans("references_product_category"))),
              ]),
              _c("SimpleDropdownComponent", {
                attrs: {
                  dataSource: _vm.categories,
                  displayProp: "name",
                  changeUrl: false,
                },
                model: {
                  value: _vm.category,
                  callback: function ($$v) {
                    _vm.category = $$v
                  },
                  expression: "category",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mb-0 col mb-sm-2 simple-dropdown-wrapper" },
            [
              _c("p", { staticClass: "bodytext mb-1" }, [
                _vm._v(_vm._s(_vm.trans("references_country"))),
              ]),
              _c("SimpleDropdownComponent", {
                attrs: {
                  dataSource: _vm.countries,
                  displayProp: "name",
                  changeUrl: false,
                },
                model: {
                  value: _vm.country,
                  callback: function ($$v) {
                    _vm.country = $$v
                  },
                  expression: "country",
                },
              }),
            ],
            1
          ),
          _vm.isEnabledBuildingStateFilter()
            ? _c(
                "div",
                { staticClass: "mb-0 col mb-sm-2 simple-dropdown-wrapper" },
                [
                  _c("p", { staticClass: "bodytext mb-1" }, [
                    _vm._v(_vm._s(_vm.trans("references_building_state"))),
                  ]),
                  _c("SimpleDropdownComponent", {
                    attrs: {
                      dataSource: _vm.buildingStates,
                      displayProp: "name",
                      changeUrl: false,
                    },
                    model: {
                      value: _vm.buildingState,
                      callback: function ($$v) {
                        _vm.buildingState = $$v
                      },
                      expression: "buildingState",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row lc-proj-paginator" }, [
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "lc-proj-cnt" }, [
          _vm._v(
            _vm._s(_vm.paginator.total) +
              " " +
              _vm._s(_vm.trans("references_projects"))
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "col-sm-9" },
        [
          _vm.paginatorType == "paginator" && _vm.paginator.last_page > 1
            ? _c("PaginatorComponent", {
                attrs: {
                  selectedPage: _vm.paginator.current_page,
                  pagesCnt: _vm.paginator.last_page,
                },
                on: { pageSelected: _vm.pageSelected },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "lc-project-list row" },
      _vm._l(_vm.projects, function (project) {
        return _c("ProjectComponent", {
          key: project.id,
          attrs: { project: project },
          on: { navigatedTo: _vm.navigated },
        })
      }),
      1
    ),
    _vm.paginatorType == "more" && _vm.showLoader
      ? _c("div", { staticClass: "preloader" }, [_c("loader")], 1)
      : _vm._e(),
    _c(
      "div",
      { staticClass: "lc-proj-paginator" },
      [
        _vm.paginatorType == "paginator" && _vm.paginator.last_page > 1
          ? _c("PaginatorComponent", {
              attrs: {
                selectedPage: _vm.paginator.current_page,
                pagesCnt: _vm.paginator.last_page,
              },
              on: { pageSelected: _vm.pageSelected },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm.paginatorType == "more" &&
    _vm.paginator.current_page < _vm.paginator.last_page
      ? _c("div", { staticClass: "text-center" }, [
          _c(
            "a",
            {
              staticClass: "button type-3 mb-0 mt-5",
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  return _vm.showMore()
                },
              },
            },
            [_vm._v(_vm._s(_vm.trans("products_show_more")))]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }